import { useState } from "react"

export const Personalization = () => {
    const [startHere, setStartHere] = useState({
        toggled: false,
    })
    const [walkthrough, setWalkthrough] = useState({
        general: false,
        publication: false,
        save: false
    })
    return {
        startHere: {data: startHere, set: setStartHere},
        walkthrough: {data: walkthrough, set: setWalkthrough},
    }
}